module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.071fcca9.ttf";